<template>
  <v-container>
    <getting-data-overlay :is_loading="is_loading"
                          :loading_display_title="$vuetify.lang.t('$vuetify.work_report.buildingListTitle')"></getting-data-overlay>
    <v-row v-if="!is_loading && !hasCriticalError">
      <v-col cols="12">
        <v-form
            ref="workReportForm"
        >

          <h3 class="mb-2">{{ $vuetify.lang.t('$vuetify.work_report.title') }}</h3>
          <ccl-component :closing-checklist-items="closingChecklistFormData"
                         :form-disabled="formDisabled"></ccl-component>
          <v-textarea
              v-model="work_report_input"
              counter
              :workReportMaxLength="workReportMaxLength"
              no-resize
              rows="6"
              ref="inputRef"
              :label="$vuetify.lang.t('$vuetify.work_report.placeholder')"
              autofocus
              :disabled="formDisabled"
              :rules="workReportRules"
              class="mt-3 mb-2"
              tabindex="98"
          ></v-textarea>
          <div class="text-center text-md-left mt-4">
            <v-btn class="white--text" color="primary" @click="checkFormState" tabindex="99">
              {{ $vuetify.lang.t('$vuetify.global.confirmAndSend') }}
            </v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
    <crit-err :shown="hasCriticalError" :title="$vuetify.lang.t('$vuetify.work_report.criticalErrorTitle')"
              code="CE-CCL-INVALID-LIST-00" :is_cancelable="true" :closeBtnText="$vuetify.lang.t('$vuetify.global.ok')"
              :interceptsClose="true" @closeClicked="navigateHome">
      {{ $vuetify.lang.t('$vuetify.customLmraLists.criticalErrorBody') + errorMessage }}
    </crit-err>
    <locationPopup :is-visible="showPrivateLocationPopup" @checkComplete="save"></locationPopup>
  </v-container>
</template>

<script>
import {mobileCheckMixin} from "../../../mixins/MobileCheckMixin/MobileCheckMixin";
import PrivateLocationCheckComponent from '../global/privateLocationChecker/PrivateLocationCheckComponent';
import urlParamsConstructor from '../../../mixins/config/urlParamsConstructor';
import workSessionMixin from "@/workSessions/mixins/workSessionMixin";
import {ENTRY_DATA_KEY, LMRADataObjectHelper, WORK_STATE_STOP} from "@/api/repository/helpers/LMRADataObjectHelper";
import lmraDataRepositoryApi from "@/api/repository/lmraDataRepositoryApi";
import sendingLmraDataHelper from "@/helpers/sendingLmraDataHelper";
import ClosingChecklistVariantComponentMixin
  , {
  CLOSING_CHECKLIST_DATA_KEY,
} from "@/mixins/closingChecklistMixin/ClosingChecklistVariantComponentMixin";

export default {
  name: "WorkReportComponent",
  mixins: [mobileCheckMixin, urlParamsConstructor, workSessionMixin, ClosingChecklistVariantComponentMixin],
  data: () => {
    return {
      formDisabled: false,
      work_report_input: '',
      workReportMinLength: 4,
      workReportMaxLength: 800,
      showPrivateLocationPopup: false,
    }
  },
  components: {
    locationPopup: PrivateLocationCheckComponent,
  },
  methods: {
    checkFormState(){
      if (this.$refs.workReportForm.validate()) {
        this.doLocationCheck();
      }
    },
    doLocationCheck() {
        this.showPrivateLocationPopup = true;
    },
    navigateHome() {
      this.$router.replace("/")
    },
    async save() {
      this.showPrivateLocationPopup = false;
      this.formDisabled = true;
      let dataObject = await LMRADataObjectHelper.buildBaseLmraDataObject();
      dataObject[ENTRY_DATA_KEY]['summary'] = this.work_report_input.trim();
      dataObject[ENTRY_DATA_KEY]['work_state'] = WORK_STATE_STOP;


      if (this.requiresClosingChecklist) {
        //window.console.log('I REQUIRE THE CLOSING CHECKLIST !!!')
        let qData = await this.getClosingChecklistDataForDataTransfer();
        dataObject[ENTRY_DATA_KEY][CLOSING_CHECKLIST_DATA_KEY] = qData;
      }

      /*window.console.log('AFTER REQUIRE CHECK WHAT IS THE CONTENT?');
      window.console.log(dataObject);*/

      /* START SENDING PART (DIFFERENT THAN OTHERS!!) */
      await lmraDataRepositoryApi.sendWorkReport(dataObject).then(
          response => {
            let message = this.$vuetify.lang.t('$vuetify.global.post_success');
            if (response.data.message !== undefined) {
              message = response.data.message;
            }

            this.clearWorkSession();
            sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(message);
            this.$router.replace('/');

            //RELEASE THE SESSION LOCK!
          })
          .catch(err => {
            sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(this.$vuetify.lang.t('$vuetify.errors.data_save_failed') + ' err: ' + err.message);
            this.formDisabled = false;
          });
      /* END SENDING PART */
    },
    clearWorkSession() {
      //TODO EXTRA VALIDATION?? OR CHECKS?
      this.$store.dispatch('clearSavedSessionData');
    }
  },
  computed: {
    /*isFilled: function () {
      let trimmed = this.work_report_input.trim();
      if (trimmed.length >= this.workReportMinLength && !this.formDisabled && this.work_report_input.length <= this.workReportMaxLength) {
        return false;
      } else {
        return true
      }
    },*/
    workReportRules: function () {
      const rules = [];
      const minLengthRule = v =>
          (v || '').length >= this.workReportMinLength ||
          this.$vuetify.lang.t('$vuetify.global.mandatory_field');
      rules.push(minLengthRule);
      const maxLengthRule = v =>
          (v || '').length <= this.workReportMaxLength ||
          `A maximum of ${this.workReportMaxLength} characters is allowed`;
      rules.push(maxLengthRule);
      return rules;

    }
  },
  created() {
  },
  beforeDestroy: function () {
    window.console.log('BEFORE DESTROY');
    if (!this.sessionExpired) {
      window.console.log('SESSION IS NOT EXPIRED YET');
      this.$workSessions.forceCloseWorkSession = false;
    }
  }
}
</script>

<style scoped>

</style>